module.exports = __webpack_public_path__ + "static/media/chinese_01.e598ed15.jpg";